module.exports = __webpack_public_path__ + "static/google-logo-978d1cfc672a2e55f76ac03c10571a4b.png";